import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="phone"
export default class extends Controller {
  static targets = ["input"]
  connect() {
    this.onlyAllowNumbers = this.onlyAllowNumbers.bind(this);

    this.iti = window.intlTelInput(this.inputTarget, {
      initialCountry: "hu",
      strictMode: true,
      separateDialCode: true
    });

    this.inputTarget.addEventListener("input", this.onlyAllowNumbers);
  }

  onlyAllowNumbers(event) {
    const input = event.target;
    input.value = input.value.replace(/[^\d+]/g, "");
  }

  disconnect() {
    if (this.iti) {
      this.iti.destroy();
      this.iti = null;
    }
    this.inputTarget.removeEventListener("input", this.onlyAllowNumbers);
  }
}